// 创建自定义指令
// directives/autoScroll.js
export const autoScroll = {
mounted(el, binding) {
    // 获取 el-table 的滚动容器
    // 注意：Element Plus 的表格滚动容器类名通常是 .el-scrollbar__wrap 或 .el-table__body-wrapper
    const scrollContainer = el.querySelector('.el-scrollbar__wrap') || el.querySelector('.el-table__body-wrapper');
    
    if (!scrollContainer) return;

    // 获取配置参数：speed (速度), step (步长)
    const speed = binding.value?.speed || 50; 
    const step = binding.value?.step || 1;

    let timer = null;

    const startScroll = () => {
      if (timer) return;
      timer = setInterval(() => {
        // 滚动距离增加
        scrollContainer.scrollTop += step;

        // 判断是否滚动到底部，如果到底则回到底部（实现无缝循环效果需特殊处理，这里为简单回顶）
        if (scrollContainer.scrollHeight - scrollContainer.scrollTop <= scrollContainer.clientHeight + 1) {
          scrollContainer.scrollTop = 0;
        }
      }, speed);
    };

    const stopScroll = () => {
      clearInterval(timer);
      timer = null;
    };

    // 鼠标悬停停止滚动，离开继续
    el.addEventListener('mouseenter', stopScroll);
    el.addEventListener('mouseleave', startScroll);

    // 存储引用以便在 unmounted 中销毁
    el._stopScroll = stopScroll;
    
    startScroll();
  },
  
  unmounted(el) {
    if (el._stopScroll) {
      el._stopScroll();
    }
  }
}